import { styled } from '@mui/material/styles';
import React from 'react';
import { Menu } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useNavigationDrawerState } from '../../Providers';
import { LeftAppBarButton } from '@lialo/pwa-ui/lib/PageComponents/AppBar';

const StyledLeftAppBarButton = styled(LeftAppBarButton)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'none',
  },
}));

interface IProps {
  className?: string;
}

const DrawerMenu = (props: IProps) => {
  const { t } = useTranslation();
  const { toggleState } = useNavigationDrawerState();

  return (
    <StyledLeftAppBarButton
      className={props.className}
      onClick={toggleState}
      ariaLabel={t('actions.menu')}
      icon={<Menu />}
    />
  );
};

export default DrawerMenu;
